// import util from "@/util";

export default {
  create({ timeslotCollectionId }, data) {
    return {
      // timslot collection
      tscId: timeslotCollectionId,

      // [Integer]
      sortidx: data.sortidx || 1,

      // [String]
      selectedWeekdays: data.selectedWeekdays || '--x--x-',

      // [Time ISO 8601]
      from: data.from || '15:00',

      // [Time ISO 8601] or <null>
      to: data.to || '18:00',

      // [Date ISO 8601] or <null>
      valid_after: data.valid_after || null,

      // [Date ISO 8601] or <null>
      valid_before: data.valid_before || null,
    };
  },

  fields: {
    tscId: { validate_bolt_type: 'PushID' },
    sortidx: { validate_bolt_type: 'Number' },
    selectedWeekdays: { validate_bolt_type: 'String' },
    from: { validate_bolt_type: 'String' },
    to: { validate_bolt_type: 'String' },
    valid_after: { validate_bolt_type: 'Timestamp' },
    valid_before: { validate_bolt_type: 'Timestamp' },
  }
}
